export default __webpack_public_path__ + "static/media/Tim.bdf7b02d.png";